<!-- =========================================================================================
  File Name: SimulationStarter.vue
  Description: eCommerce Item Detail page

========================================================================================== -->

<template>
  <div v-if="simulation_data" id="item-detail-page">
    <div v-if="$acl.check('proctor')" class="flex items-center justify-end mb-3">
      <p class="mr-2">Admin Mode</p>
      <vs-switch v-model="enable_edit_mode" color="success"></vs-switch>
    </div>

    <vs-alert :active.sync="errorOccurred" color="danger" title="Error Fetching Simulation Data">
      <span>{{ error_msg }}. </span>
      <span>
        <span>Check </span><router-link class="text-inherit underline" to="/simulation/search">All Simulations</router-link>
      </span>
    </vs-alert>

    <!--- SIM START CARD --->
        <vx-card v-if="simulation_data" :key="simulation_data.id"
                 :style="{'background-image': 'url(' + simulation_data.thumbnail + ')',  'background-size': 'cover', }"
                 class="mb-base">

          <template slot="no-body">

            <div class="item-content vs-card-radius" style="backdrop-filter: blur(10px);">
              <vs-progress :percent="simulation_completion" class="block shadow-md bg-danger" color="success" v-if="simulation_completion !== 0"></vs-progress>
              <vs-progress :percent="100" class="block shadow-md" color="danger" v-else></vs-progress>
              <!-- Item Main Info -->
              <div class="product-details p-6">
                <div class="vx-row mt-2">
                  <!-- Item Content -->
                  <div v-if="!simulation_data.demonstration_video_id && simulation_data.thumbnail"
                       class="vx-col md:w-2/5 w-full flex items-center justify-center">
                    <div class="product-img-container mx-auto mb-10 md:mb-0" >
                      <img :alt="simulation_data.name" :src="simulation_data.thumbnail" class="responsive rounded">
                    </div>
                  </div>
                  <div v-else-if="simulation_data.demonstration_video_id" class="vx-col md:w-2/5 md:flex hidden justify-center items-center align-middle" >
                    <hls-player class="w-11/12 rounded-lg " player_class="rounded-lg" source="https://simulations-vimeo-auth.rapid-edu.workers.dev/?id=523583106&token=6e2f12aeaa1a795026a81b2d35bcaac63358ee8a"></hls-player>
                  </div>
                  <div v-else></div>
                  <div class="vx-col md:w-3/5 w-full">

                    <!--- simulation name --->
                    <div class="mb-10">
                      <vs-input v-if="enable_edit_mode" v-model="simulation_data.name" class="w-1/2" label-placeholder="Simulation Name"></vs-input>
                      <h1 v-else class="font-bold text-white" style="font-size: 37px">{{ simulation_data.name }} | {{ activeCourseInfo.name }}</h1>
                    </div>


                    <!--- simulation description
                    <div class="my-3">
                      <vs-textarea class="mt-4" v-if="enable_edit_mode" label="Simulation Description" counter="400" :counter-danger.sync="edit_description_counter" height="100px" v-model="simulation_data.description"/>
                      <h3 v-else class="text-white">{{ simulation_data.description }}</h3>
                    </div>
                    --->

                    <!--- simulation thumbnail --->
                    <div class="mb-6">
                      <vs-input v-if="enable_edit_mode" v-model="simulation_data.thumbnail" class="w-full" label-placeholder="Simulation Thumbnail URL"></vs-input>
                    </div>

                    <!-- simulation instructions -->
                    <div class="mb-6  rounded" style="background-color: rgba(0, 0, 0, 0.44);">
                      <quill-editor v-if="enable_edit_mode" v-model="simulation_data.instructions_content"></quill-editor>
                      <div v-else class="p-4 ">
                        <div class="text-white instructions-show-details" v-html="simulation_data.instructions_content"></div>
                      </div>
                    </div>

                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <div class="flex flex-wrap items-start mb-4">
                          <vs-row class="pb-3" vs-justify="space-between">
                            <vs-col vs-justify="space-between" vs-lg="5" vs-sm="12" vs-type="flex">
                              <vs-button
                                v-if="enable_edit_mode"
                                class="w-full font-bold text-lg" color="success"
                                icon="icon-edit" icon-pack="feather" type="border"
                                @click="update_simulation">Update Simulation
                              </vs-button>
                              <vs-button
                                v-else
                                :disabled="start_button_disabled"
                                svgClasses="w-12 h-12"
                                style="font-size: 22px"
                                class="w-full mb-4 mt-5 font-bold "
                                icon="icon-play" icon-pack="feather" color="primary"
                                @click="start_simulation(simulation_data)">Start Simulation
                              </vs-button>
                            </vs-col>
                          </vs-row>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </template>


          <!--- SIM PROGRESS CARD --->
        </vx-card>

    <div class="vx-row mb-base">
      <!-- CARD 9: DISPATCHED ORDERS -->
      <div class="vx-col w-full">
        <vx-card title="Quick Insights">
          <template slot="actions">
            Showing Today's Progress
          </template>
          <div class="vx-row items-center ">
            <div class="vx-col xl:w-1/4 lg:w-1/2 sm:w-1/2 md:w-1/2">
              <dashboard-statistics-card-line
                :statistic="this.simulation_progress !== null ? this.simulation_progress.quick_insights.sims_started : '0'"
                class="mb-base"
                hideChart
                icon="PlayCircleIcon"
                icon-right
                statisticTitle="Simulations Played"
              />
            </div>
            <div class="vx-col xl:w-1/4 lg:w-1/2 sm:w-1/2 md:w-1/2">
              <dashboard-statistics-card-line
                :statistic="this.simulation_progress !== null ? this.simulation_progress.quick_insights.sims_submissions : '0'"
                class="mb-base"
                hideChart
                icon="CodesandboxIcon"
                icon-right
                statisticTitle="Simulation Submissions"/>
            </div>
            <div class="vx-col xl:w-1/4 lg:w-1/2 sm:w-1/2 md:w-1/2">
              <dashboard-statistics-card-line
                :statistic="this.simulation_progress !== null ? this.simulation_progress.quick_insights.sims_completed : '0'"
                class="mb-base"
                hideChart
                icon="CheckCircleIcon"
                icon-right
                statisticTitle="Simulations Completed"/>
            </div>
            <div class="vx-col xl:w-1/4 lg:w-1/2 sm:w-1/2 md:w-1/2">
              <dashboard-statistics-card-line
                :statistic="this.simulation_completion !== null ? this.simulation_completion+'%' : '0%'"
                class="mb-base"
                hideChart
                icon="InfoIcon"
                icon-right
                statisticTitle="Simulation Completion"/>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <!--TODO BETTER SIMULATION PROGRESS-->
    <!---
       <div class="vx-row">
<vx-card title="Recent Attempts" class="mb-base">
       <div class="vx-row">
         <div class="vx-col w-full">
           <div slot="no-body" class="mt-4">
             <vs-table  class="table-dark-inverted">
               <template slot="thead">
                 <vs-th>ORDER NO.</vs-th>
                 <vs-th>STATUS</vs-th>
                 <vs-th>OPERATORS</vs-th>
                 <vs-th>LOCATION</vs-th>
                 <vs-th>DISTANCE</vs-th>
                 <vs-th>START DATE</vs-th>
                 <vs-th>EST DELIVERY DATE</vs-th>
               </template>

               <template slot-scope="{data}">
                 <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                   <vs-td :data="data[indextr].orderNo">
                     <span>#{{ data[indextr].orderNo }}</span>
                   </vs-td>
                   <vs-td :data="data[indextr].status">
                   <span class="flex items-center px-2 py-1 rounded"><div class="h-3 w-3 rounded-full mr-2"
                                                                          :class="'bg-' + data[indextr].statusColor"></div>{{
                       data[indextr].status
                     }}</span>
                   </vs-td>
                   <vs-td :data="data[indextr].orderNo">
                     <ul class="users-liked user-list">
                       <li v-for="(user, userIndex) in data[indextr].usersLiked" :key="userIndex">
                         <vx-tooltip :text="user.name" position="bottom">
                           <vs-avatar :src="user.img" size="30px"
                                      class="border-2 border-white border-solid -m-1"></vs-avatar>
                         </vx-tooltip>
                       </li>
                     </ul>
                   </vs-td>
                   <vs-td :data="data[indextr].orderNo">
                     <span>{{ data[indextr].location }}</span>
                   </vs-td>
                   <vs-td :data="data[indextr].orderNo">
                     <span>{{ data[indextr].distance }}</span>
                     <vs-progress :percent="data[indextr].distPercent" :color="data[indextr].statusColor"></vs-progress>
                   </vs-td>
                   <vs-td :data="data[indextr].orderNo">
                     <span>{{ data[indextr].startDate }}</span>
                   </vs-td>
                   <vs-td :data="data[indextr].orderNo">
                     <span>{{ data[indextr].estDelDate }}</span>
                   </vs-td>
                 </vs-tr>
               </template>
             </vs-table>
           </div>
         </div>
       </div>
     </vx-card>
   </div>
-->

  </div>
  <div v-else>
    <div class="simple-spinner">
      <span></span>
    </div>
  </div>

</template>

<script>
import 'quill/dist/quill.snow.css'

import VueApexCharts from 'vue-apexcharts'
import analyticsData from '@/components/analyticsData'
import DashboardStatisticsCardLine from '@/components/statistics-cards/DashboardStatisticsCardLine'
import { quillEditor } from 'vue-quill-editor'


export default {
  components: {
    VueApexCharts,
    DashboardStatisticsCardLine,
    quillEditor
  },
  data () {
    return {

      simulation_data: null,
      simulation_progress: null,

      simulation_completion: null,

      price_selected: {
        priceDisplay: 'loading...'
      },

      errorOccurred: false,
      error_msg: '',

      enable_edit_mode: false,
      edit_description_counter: 0,

      start_button_disabled: false,

      analyticsData
    }
  },
  methods: {
    start_simulation () {
      try {
        if (window.VGReady === false) {
          this.start_button_disabled = true
          this.$VoriantGuard.connect().then(() => {
            this.$vs.notify({
              title: 'Please Wait',
              text: 'We are attempting to connect you to the progress server',
              color: 'warning',
              position: 'top-right',
              icon: 'feather',
              iconPack: 'icon-clock'
            })
            const vg_success = setInterval(() => {
              if (window.VGReady === true) {
                this.$VoriantGuard.sendActivityAuthorize(this.simulation_data)
                clearInterval(vg_success)
              }
            }, 500)
            setTimeout(() => {
              clearInterval(vg_success)
              if (window.VGReady === false) {
                this.launch_offline_warning()
              }
              this.start_button_disabled = false
            }, 2250)
          })
        } else {
          this.$VoriantGuard.sendActivityAuthorize(this.simulation_data)
        }
      } catch (e) {
        this.launch_offline_warning()
      }
    },
    launch_offline_warning () {
      this.start_button_disabled = false
      this.$vs.dialog({
        type: 'confirm',
        title: 'We were unable to connect you to our progress server',
        text: 'By launching the simulation you will be launching in offline mode, your progress will not be saved to the cloud. If this reoccurs please contact our support team.',
        accept: this.redirect_simulation,
        parameters: this.simulation_data,
        acceptText: 'Launch'
      })
    },
    redirect_simulation (x) {
      this.$router.push({name: 'legacy-simulation-play', params: {simulationId: x.id}})
    },
    load_simulation_progress (id) {

      this.$http.get(`progress/p/@me/simulation/insights?simulation=${id}`)
        .then(response => {

          if (response.data.data) {
            this.simulation_progress = response.data.data

          }

        })

      this.$http.get(`progress/user/specific/@me/simulation/progress?simulation=${id}`)
        .then(response => {
          if (response.data.data) {
            this.simulation_completion = Math.round(response.data.data)
          }
        })

    },
    authorized_simulation (data) {
      const simulationData = data.d
      if (simulationData.authorized === true) {
        this.$vs.notify({
          title: `Starting ${data.d.simulation.name}`,
          text: `${this.activeCourseInfo.name} Simulation Started`,
          color: 'success',
          position: 'top-right'
        })
        this.$router.push({name: 'legacy-simulation-play', params: {simulationId: simulationData.simulation.id}})

      }

      if (data.d.authorized === false) {
        this.$vs.dialog({
          type: 'confirm',
          title: 'Another Simulation Is Already Open',
          text: 'By launching the simulation you will close the current simulation that is open. You may only have one simulation open at a time.',
          accept: this.redirect_simulation,
          parameters: data.d.simulation,
          acceptText: 'Launch'
        })
      }

    },
    fetch_item_details (id) {
      this.$http.get(`simulations/${id}`)
        .then(response => {

          if (response.status === 200) {
            this.simulation_data = response.data.data
            this.load_simulation_progress(response.data.data.id)
          }
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Error While Loading Simulation',
            text: 'Please ensure you have the course selected for the simulation you are trying to access',
            color: 'danger',
            position: 'top-right'
          })
          this.$router.push('/simulation/search')
        })
    },
    update_simulation () {
      const pl = this.simulation_data
      pl.status = this.simulation_data.status === undefined ? 'active' : this.simulation_data.status
      pl.difficulty = parseInt(this.simulation_data.difficulty.id)

      if (pl.name === undefined) {
        return this.$vs.notify({
          title: 'Failed to update simulation',
          text: 'Please provide a Simulation Name',
          color: 'danger',
          position: 'top-right'
        })
      }

      this.$vs.loading()

      this.$http.post(`simulations/${this.simulation_data.id}`, pl)
        .then(response => {

          if (response.status === 200) {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Updated Simulation Successfully',
              text: `Simulation ${  pl.name  } has been updated.`,
              color: 'success',
              position: 'top-right'
            })
          }

        })
        .catch(exception => {
          this.$vs.loading.close()

          let error = 'An unknown error occurred while updating this simulation'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            title: 'Failed to update simulation',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    }
  },
  mounted () {
    this.$VoriantGuard.on('event:simulation.authorize', (client, data) => {
      this.authorized_simulation(data)
    })

    this.fetch_item_details(this.$route.params.simulationId)

  },
  computed: {
    activeCourseInfo () {
      return this.$store.state.AppActiveCourse
    }
  },
  watch: {
    enable_edit_mode () {
      this.fetch_item_details(this.simulation_data.id)
    }
  },
  beforeDestroy () {
    this.simulation_data = null
  }
}
</script>

<style lang="scss">


@import "@/assets/scss/vuexy/_variables.scss";


#item-detail-page {
  .color-radio {
    height: 2.28rem;
    width: 2.28rem;

    > div {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .item-features {
    background-color: #f7f7f7;

    .theme-dark & {
      background-color: $theme-dark-secondary-bg;
    }
  }

  .product-sales-meta-list {
    .vs-list--icon {
      padding-left: 0;
    }
  }

  .vs-card-radius {
    border-radius: .5rem;
  }

  .vs-button--icon {
    font-size: 22px!important;
  }

}

.text-white.instructions-show-details {
  img {
    max-width: -webkit-fill-available;
  }
}
</style>
